<template>
  <div class="row" id="bees-and-climate">
    <div class="col-12 mb-5">
      <div class="about__box">
        <h2 class="about__headline">
          Zapylacze - fundament życia
        </h2>
        <div class="about__content">
          Zapylanie roślin to jeden z najważniejszych mechanizmów pozwalających
          utrzymać życie na Ziemi. Praca pszczół, motyli, trzmieli i innych
          zapylaczy pozwala rozmnażać się ogromnej liczbie roślin będących
          pożywieniem zwierząt i ludzi. Niestety
          <strong
            >owady są jednocześnie jednymi z pierwszych ofiar trwającego kryzysu
            ekologicznego</strong
          >. Populacje wszystkich owadów na świecie drastycznie zmniejszają się.
          Ubywa ich osiem razy szybciej niż gadów, ptaków i ssaków.<br /><br />
          Jeśli ten trend się nie zatrzyma,
          <strong
            >w ciągu najbliższych 20-30 lat może zniknąć prawie połowa gatunków
            owadów.</strong
          >
          Odpowiadają za to m.in. stosowane w rolnictwie pestycydy, kryzys
          klimatyczny oraz niszczenie i fragmentacja naturalnych siedlisk.
          <br /><br />Zniknięcie tak wielu gatunków owadów będzie oznaczało
          potężną katastrofę ekologiczną. Razem z zapylaczami znikną zapylane
          przez nie rośliny, później zwierzęta, które się nimi żywią. Ten proces
          już się rozpoczął, a jego skutki odczują również ludzie.
        </div>
        <div>
          <router-link class="about__btn" to="/pytania-i-odpowiedzi">
            Dowiedz się więcej
            <font-awesome-icon :icon="['fas', 'angle-double-right']" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutBee",
  data() {
    return {
      title: "about",
    };
  },
};
</script>
